<template>
  <div>
    <el-form ref="formRef" :model="userForm" label-width="140px">
      <el-form-item label="头像：">
        <el-image style="width: 80px; height: 80px" :src="userForm.headImg.smallHeadImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
      </el-form-item>
      <el-form-item label="信息：">
        <div class="item-info">
          <UserInfoList :row="userForm" showList="name,phone,uid,city,birth" :isDialog="true"/>
        </div>
      </el-form-item>
      <!--      <el-form-item label="状态：">-->
      <!--        <div class="item-info">-->
      <!--          <p>真人认证状态：{{userForm.baiduMatchState == 0?'未认证':userForm.baiduMatchState == 1?'已认证':userForm.baiduMatchState == 2?'认证失败':''}}</p>-->
      <!--          <p>实名认证：{{userForm.baiduAuthState == 0?'未认证':userForm.baiduAuthState == 1?userForm.baiduAuth.certCode:userForm.baiduAuthState == 2?'认证失败':''}}</p>-->
      <!--          <p>信息审核状态：{{userForm.resumeState == 0?'未提交':userForm.resumeState == 1?'待审核':userForm.resumeState == 2?'审核通过':userForm.resumeState == 3?'审核不通过':''}}</p>-->
      <!--        </div>-->
      <!--      </el-form-item>-->
      <el-form-item label="通报内容：" style="padding-top: 20px;">
        <el-select v-model="remark" value-key="value" placeholder="请选择" style="width: 26em" :disabled="remark_checked">
          <el-option v-for="item in remarkArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div style="display: flex;padding-top: 10px; width: 26em;">
          <el-checkbox v-model="remark_checked" style="margin-right: 6px; width: 8.4em" border>自定义</el-checkbox>
          <el-input v-model="remark_input" placeholder="请输入内容" :disabled="!remark_checked"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="处罚结果：" style="padding-top: 20px;">
        <el-select v-model="punishResult" value-key="value" placeholder="请选择"  style="width: 26em" :disabled="punishResult_checked">
          <el-option v-for="item in punishResultArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div style="display: flex;padding-top: 10px; width: 26em">
          <el-checkbox v-model="punishResult_checked" style="margin-right: 6px; width: 8.4em" border >自定义</el-checkbox>
          <el-input v-model="punishResult_input" placeholder="请输入内容" :disabled="!punishResult_checked"></el-input>
        </div>
      </el-form-item>
      <el-form-item>
        <div class="dialog-footer">
          <el-button @click.native="cancel" >取消</el-button>
          <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>
        </div>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { postFormData } from "@/api/api";
import { addOrUpdateIllegalNotice } from "@/api/url";
import { intReg } from "@/assets/shared/reg-constant";

export default {
  name: "IllegalSearchInfoDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userForm: this.value.userForm,
      idx: this.value.idx,
      loading: false,

      remarkArray: [
        {label: '经举报，违规透露/索要微信', value: '经举报，违规透露/索要微信'},
        {label: '经举报，辱骂他人', value: '经举报，辱骂他人'},
        {label: '经举报，非单身/已婚', value: '经举报，非单身/已婚'},
        {label: '经举报，广告推销', value: '经举报，广告推销'},
        {label: '经举报，批量发广告', value: '经举报，批量发广告'}
      ],
      remark: '经举报，违规透露/索要微信',
      remark_checked: this.value.idx > -1?true:false,
      remark_input: this.value.idx > -1? this.value.userForm.remark : '',

      punishResultArray: [
        {label: '警告', value: '警告'},
        {label: '禁言1天', value: '禁言1天'},
        {label: '禁言3天', value: '禁言3天'},
        {label: '禁言7天', value: '禁言7天'},
        {label: '禁言14天', value: '禁言14天'},
        {label: '禁言30天', value: '禁言30天'},
        {label: '永久封号', value: '永久封号'}
      ],
      punishResult: '警告',
      punishResult_checked: this.value.idx > -1?true:false,
      punishResult_input: this.value.idx > -1? this.value.userForm.punishResult : '',

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    submit() {
      if(this.remark_checked && !this.remark_input) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入自定义通报内容',
          type: 'warning'
        });
        return;
      }
      if(this.punishResult_checked && !this.punishResult_input) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入自定义处罚结果',
          type: 'warning'
        });
        return;
      }
      this.loading = true
      let param = {}
      param['id'] = this.idx > -1?this.userForm.id:0
      param['userId'] = this.userForm.userId
      param['remark'] = this.remark_checked?this.remark_input:this.remark,
      param['punishResult'] = this.punishResult_checked?this.punishResult_input:this.punishResult,
      postFormData(addOrUpdateIllegalNotice, param).then((data) => {
        let {code, msg} = data
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm', param)
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },

    checkValue() {
      this.remarkArray.forEach(item => {
        if (item.value == this.value.userForm.remark){
          this.remark = this.value.userForm.remark;
          this.remark_checked = false;
          this.remark_input = '';
        }
      });
      this.punishResultArray.forEach(item => {
        if (item.value == this.value.userForm.punishResult){
          this.punishResult = this.value.userForm.punishResult;
          this.punishResult_checked = false;
          this.punishResult_input = '';
        }
      })
    },

  },
  created() {
    if(this.idx > -1) {
      this.checkValue()
    }
  }
}
</script>

<style scoped>
.item-info {
  margin-top: 4px;
}
.item-info p {
  line-height: 24px;
}
</style>
